/*
 * Copyright (c) 2021. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import z from 'zod';
export const paginationValidation = {
    limit: z.number().int().min(0).default(100),
    offset: z.number().int().min(0).default(0),
};
export const configQuerySchema = z.object({
    ...paginationValidation,
    name: z.coerce.string().nullable().optional(),
    showArchived: z.boolean().default(false),
    orderby: z.string().optional(),
    descending: z.boolean().optional(),
    id: z.string().optional(),
    selectedIds: z.string().optional(),
    latestVersionOnly: z.boolean().optional().default(true),
    onlyMine: z.boolean().optional().default(false),
    projectId: z.string().optional(),
    listOnly: z.boolean().default(false),
    customAttrsStr: z.string().optional(),
    startDate: z.iso.datetime().optional(),
    endDate: z.iso.datetime().optional(),
});
export const formNewConfigPayload = (requestSchema) => z.object({
    name: z.string(),
    request: requestSchema,
    project_id: z.string().nullable().optional(),
    comment: z.string().nullable().optional(),
});
//# sourceMappingURL=config.js.map